var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardSensors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 23,
    viewBox: "0 0 34 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.869 15c2.233 0 4.044 1.79 4.044 4s-1.81 4-4.044 4c-2.234 0-4.045-1.79-4.045-4s1.811-4 4.045-4Zm0 2a2.011 2.011 0 0 0-2.022 2c0 1.105.905 2 2.022 2a2.011 2.011 0 0 0 2.022-2c0-1.105-.905-2-2.022-2Zm0-7a9.113 9.113 0 0 1 7.99 4.69l-1.775.958A7.088 7.088 0 0 0 16.869 12a7.088 7.088 0 0 0-6.215 3.648l-1.776-.958a9.113 9.113 0 0 1 7.99-4.69Zm0-5a14.176 14.176 0 0 1 12.43 7.296l-1.776.957A12.15 12.15 0 0 0 16.869 7a12.15 12.15 0 0 0-10.654 6.253l-1.776-.957A14.176 14.176 0 0 1 16.869 5Zm0-5a19.239 19.239 0 0 1 16.869 9.9l-1.776.958A17.214 17.214 0 0 0 16.869 2C10.358 2 4.693 5.58 1.776 10.858L0 9.9C3.26 4.001 9.592 0 16.869 0Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSensors);
export default __webpack_public_path__ + "static/media/DashboardSensors.d7e2dd477f282fa3fda1091c6c116574.svg";
export { ForwardRef as ReactComponent };